import { create } from 'zustand';

export interface EnvironmentStore {
  /** Currently selected environment ID, persisted across pages/tabs */
  selectedEnvironmentId: string;
  setSelectedEnvironmentId: (id: string) => void;
}

export const useEnvironmentStore = create<EnvironmentStore>((set) => ({
  selectedEnvironmentId: '',
  setSelectedEnvironmentId: (id: string) => set({ selectedEnvironmentId: id }),
}));
